import { RBIEnv, brand, graphqlEnv } from 'utils/environment';

export const LAMBDA_GQL =
  graphqlEnv() === RBIEnv.TEST
    ? 'http://localhost:3001/graphql'
    : `https://${graphqlEnv()}-${brand()}.rbictg.com/graphql`;

export enum QUERY_TYPE {
  LambdaGraphqlQuery,
  SanityGroqQuery,
  SanityGraphqlQuery
}

export const API_GATEWAY_GQL =
  graphqlEnv() === RBIEnv.TEST
    ? 'http://localhost:3002/gateway/graphql'
    : `https://${graphqlEnv()}-${brand()}.rbictg.com/gateway/graphql`;

export enum HttpErrorCodes {
  BadRequest = 400,
  InternalServerError = 500,
  TooManyRequests = 429,
  Unauthorized = 401
}
